export default "__VITE_ASSET__C1ToIpn4__"